import { render, staticRenderFns } from "./group_six_full.vue?vue&type=template&id=bdcd53b4&"
import script from "./group_six_full.vue?vue&type=script&lang=js&"
export * from "./group_six_full.vue?vue&type=script&lang=js&"
import style0 from "./group_six_full.vue?vue&type=style&index=0&id=bdcd53b4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports